import { TYPES } from "./default_setting.type";
import { onSnapshot, doc } from "firebase/firestore";
//func
import { getRefs } from "../ref";

// ========= firebase function =========//

//snap all provider
const allDefaultSettingSub = [];
export const snapDefaultSetting = (callback) => (dispatch) => {
  setDefaultSettingBailiffSuccess(dispatch, null);
  const cRef = getRefs().setting;
  const id = "bailiff-payment";
  const qRef = doc(cRef, id);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.data();
      setDefaultSettingBailiffSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultSettingSub.push(unsub);
};

export const unSnapDefaultSetting = () => (dispatch) => {
  allDefaultSettingSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultSettingSub.length = 0;
};
// ========= cloud function =========//
// ========= local function =========//
export const setDefaultSettingBailiff = (data, callback) => (dispatch) => {
  setDefaultSettingBailiffSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultSettingBailiffSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_SETTING_BAILIFF,
    payload: data,
  });
};
